import React from "react";
import { Collapse } from "antd";
import { CollapseWrapper } from "./style";
import { FaAngleDown } from "react-icons/fa";

const { Panel } = Collapse;

const AntdAccordionCard = ({ title, shipments, onChange, cardsData, fee, ...props }) => {

  return (
    <CollapseWrapper>
      {!cardsData ? <Collapse style={{ marginBottom: 12 }} onChange={onChange} expandIcon={({ isActive }) => (
        <FaAngleDown
          style={{ fontSize: "18px", top: '5px', right: '12px', color: '#1565D8', transition: "transform 0.2s", transform: `rotate(${isActive ? 180 : 0}deg)` }}
        />
      )} {...props} className="custom-collapse" expandIconPosition="right">
        <Panel header={title} key="1">
          <div className="card-content">
            <div className="info">
              <strong>Total Shipments</strong>
              <p>{shipments}</p>
            </div>
            <div className="info">
              <strong>Shipments Fee</strong>
              <p>${fee}</p>
            </div>
          </div>
        </Panel>
      </Collapse>
        : <div className="left-collapse-able"><Collapse defaultActiveKey="1" expandIconPosition="left" expandIcon={({ isActive }) => (
          <FaAngleDown
            style={{ fontSize: "18px", left: 3, top: 13, color: '#1565D8', transition: "transform 0.2s", transform: `rotate(${isActive ? 180 : 0}deg)` }}
          />
        )} {...props} className="custom-collapse">
          <Panel header={title} key="1">
            {cardsData}
          </Panel>
        </Collapse></div>}
    </CollapseWrapper>
  );
};

export default AntdAccordionCard;
